<template>
    <div>
        <scheduler company="false" :items.sync="schedule"></scheduler>
        <button-loading
            type="button"
            :loading="loading"
            @click="save()"
            class="btn btn-primary"
        >{{$t('Update schedule')}}</button-loading>
    </div>
</template>

<script>
import Scheduler from "@/components/Scheduler.vue";
import ButtonLoading from '@/components/ButtonLoading'
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    data() {
        return {
            schedule: [],
            loading: false

        }
    },
    components: {
        Scheduler,
        ButtonLoading
    },
    created() {
        this.schedule = this.user.schedule;
    },
    computed: {
        ...mapState('auth', [
            'user'
        ]),
        ...mapGetters('users', {
            getUserById: 'get'
        }),

    },
    methods: {
        ...mapActions('users', {
            updateUser: 'patch'
        }),
        save() {
            this.loading = true;
            this.updateUser([this.user._id, { schedule: this.schedule }, {}]).then(result => {
                this.loading = false;
                this.$toasted.global.success({
                    message: this.$t('Profile has been updated')
                });
            }).catch(error => {
                this.loading = false;
                this.$toasted.global.error({
                    message: `Error while updating profile. ${error.message}`
                });
            });
        }
    }
}
</script>

<style>

</style>
